import { HTTP } from './helpers/http.js'

export default {
  text(organizationId, textToTranslate, targetLanguage) {
    const url = `/api/v1/organizations/${organizationId}/ai/translation/translations`
    const data = {
      textToTranslate,
      targetLanguage,
    }

    return HTTP.post(url, data)
  },
}
